import authViewer from './authViewer'
import plaka from './plaka'

export { authViewer, plaka }
export default [authViewer, plaka]
